import { render } from "./btn-history.vue?vue&type=template&id=a1d7fb8a&ts=true"
import script from "./btn-history.component?vue&type=script&lang=ts"
export * from "./btn-history.component?vue&type=script&lang=ts"

import exportComponent from "D:\\trainsit project\\LTMS\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__